import styled from 'styled-components';

export const AutocompleteWrapper = styled.div`
  position: relative;
`;
